import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { payEmdInliveroom } from "../../../../../redux/action/liveRoom";
import { ClipLoader } from "react-spinners";
import { notifyError } from "../../../../../helpers/helpers";

function PayemdInLiveRoom({ liveOfferData, setIsModalOpen }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { profile } = useSelector((state) => state?.profileStore);
  const { payEmdInLiveLoading } = useSelector((state) => state.liveAuctionList);
  const { organization } = useSelector((pre) => pre?.organizationDetails);
  
  const submitPayEmd = () => {
    const offers = [
      {
        offer: liveOfferData?._id,
        EMDAmount: liveOfferData?.EMDAmount,
      },
    ];

    if (!organization?.PCBVerified && liveOfferData?.requiresPCBCertificate) {
      notifyError("Please verify your PCB certificate to proceed with the payment.");
      setIsModalOpen(false);
      return;
     }

    dispatch(
      payEmdInliveroom(id, profile?.organization,profile?._id, { offers }, setIsModalOpen)
    ).then(() => (document.body.style.overflow = "auto"));
  };



  return (
    <div>
      <h4>
        Confirm Payment for{" "}
        <span className="cercle-purple-text font-20px">
          {liveOfferData?.scrapDetails?.type}
        </span>{" "}
        lots.
      </h4>
      <p>
        Are you sure you want to proceed with the EMD payment? Please review the
        details before confirming. Once the payment is made, it cannot be
        reversed.
      </p>
      <div className="flex justify-end gap-1 mt-2">
        <button className="green btn-small" onClick={submitPayEmd}>
          {payEmdInLiveLoading ? (
            <ClipLoader color="red" size={20} />
          ) : (
            "Confirm"
          )}
        </button>
        <button className="red btn-small" onClick={() => setIsModalOpen(false)}>
          No
        </button>
      </div>
    </div>
  );
}

export default PayemdInLiveRoom;
